import { render, staticRenderFns } from "./ordersListButton.vue?vue&type=template&id=7a02b0c9&scoped=true"
import script from "./ordersListButton.vue?vue&type=script&lang=js"
export * from "./ordersListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02b0c9",
  null
  
)

export default component.exports